import { useState, useEffect } from 'react';
import { tagColorsStore } from '@/store/tagColors';

export function useTagColors() {
  const [colors, setColors] = useState<Record<string, string>>(tagColorsStore.getColors());

  useEffect(() => {
    return tagColorsStore.subscribe(() => {
      setColors(tagColorsStore.getColors());
    });
  }, []);

  return {
    colors,
    setTagColor: (tag: string, color: string) => tagColorsStore.setColor(tag, color),
    removeTagColor: (tag: string) => tagColorsStore.removeColor(tag),
  };
}